import React, { useState, useEffect } from "react";
import { Table, Button, Container, Alert, Spinner } from "react-bootstrap";
import { fetchOrders } from "../../Service/Order.service";
import { Link, Navigate } from "react-router-dom";
import './OrderForm.css';
import Header from '../../components/HeaderTop/HeaderTop'

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;

  // Get user role from localStorage
  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.user_role === 4;

  useEffect(() => {
    const loadOrders = async () => {
      try {
        const data = await fetchOrders();
        setOrders(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    if (isAdmin) {
      loadOrders();
    }
  }, [isAdmin]);

  // Redirect if not admin
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }

  // Pagination logic
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(orders.length / ordersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Loading
  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  // Error
  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <> <Header/>
    <Container className="mt-5">
     
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Injera Orders</h2>
        <div className="flex justify-space-between">
          <Button as={Link} to="../d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/user" variant="secondary" className="mx-5">
            User Management
          </Button>
          <Button as={Link} to="/orders/new" variant="primary" className="mr-5">
            Create New Order
          </Button>
        </div>
      </div>

      <Table striped bordered hover responsive>
        <thead className="bg-primary">
          <tr>
            <th>#</th>
            <th>Customer</th>
            <th>Phone</th>
            <th>Delivery Date</th>
            <th>Red Injera</th>
            <th>White Injera</th>
            <th>Total Price</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentOrders.map((order, index) => {
            const displayId = indexOfFirstOrder + index + 1;
            return (
              <tr key={order.order_id}>
                <td>{displayId}</td>
                <td>{order.customer_name}</td>
                <td>{order.phone}</td>
                <td>{new Date(order.delivery_date).toLocaleDateString()}</td>
                <td>{order.red_injera_quantity}</td>
                <td>{order.white_injera_quantity}</td>
                <td>${0}</td>
                <td>
                  <span className={`status-badge ${
                    order.order_status === "Confirmed"
                      ? "status-completed"
                      : order.order_status === "Pending"
                      ? "status-pending"
                      : order.order_status === "Cancelled"
                      ? "status-cancelled"
                      : order.order_status === "Processing"
                      ? "status-processing"
                      : order.order_status === "Delivered"
                      ? "status-delivered"
                      : "status-default"
                  }`}>
                    {order.order_status}
                  </span>
                </td>
                <td>
                  <Button
                    as={Link}
                    to={`/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/${order.order_id}`}
                    variant="info"
                    size="sm"
                    className="me-2"
                  >
                    View
                  </Button>
                  <Button
                    as={Link}
                    to={`/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/${order.order_id}/edit`}
                    variant="primary"
                    size="sm"
                    className="me-2"
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <div className="d-flex justify-content-center">
        <Button
          variant="outline-primary"
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="me-2"
        >
          Previous
        </Button>
        <span className="align-self-center mx-3">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          variant="outline-primary"
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </Container>
    </>
  );
};

export default OrderList;